<template>
    <v-col cols="12">
      <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
        <v-list>
          <v-list-item v-for="(item, index) in contextMenuItems" :key="index" @click="clickContextItem(item)">
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!--<v-data-table :headers="headers" :items="batches" :items-per-page="20" class="elevation-1" @contextmenu:row="clickContext()"></v-data-table>-->
      <v-data-table :headers="headers" :items="batches" @click:row="clickRow" class="elevation-1">
        <template v-slot:item.Name="{ item }">
          {{ item.Name + ' ' + item.ClassNames }}
        </template>
        <template v-slot:item.Exported="{ item }">
          <v-icon v-if="item.Exported === true" small>
            mdi-check-outline
          </v-icon>
          <v-icon v-if="item.Action" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="batchDeleteDialog" width="30%">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            System Info
          </v-card-title>
          <v-card-text>
            <br/>
            {{$t('batches.deleteinfo')}} ({{(this.selectedItem) ? this.selectedItem.Name : ''}})?
            <br/>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="warning" text @click="clickDeleteBatch()">{{$t('batches.delete')}}</v-btn>
            <v-btn color="primary" text @click="batchDeleteDialog = false">{{$t('batches.cancel')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
</template>

<script>

import Models from '@/Models'

export default {
  name: 'BatchList',
  props: ['batches', 'ws'],
  data () {
    return {
      batchDeleteDialog: false,
      selectedItem: null,
      headers: [
        {
          text: this.$i18n.t('batches.name'),
          align: 'start',
          sortable: true,
          value: 'Name'
        },
        // { text: this.$i18n.t('batches.id'), value: 'Id' },
        { text: this.$i18n.t('batches.date'), sortable: true, value: 'Date' },
        { text: this.$i18n.t('batches.exported'), sortable: true, value: 'Exported' },
        { text: this.$i18n.t('batches.type'), sortable: true, value: 'Type' },
        { text: this.$i18n.t('batches.totaldoc'), sortable: true, value: 'TotalDocs' },
        { text: this.$i18n.t('batches.totalpages'), sortable: true, value: 'TotalPages' },
        { text: this.$i18n.t('batches.action'), sortable: false, value: 'action' }
      ],
      showMenu: false,
      x: 0,
      y: 0,
      contextMenuItems: [{ title: 'Remove Batch', type: 'remove_batch', icon: 'mdi-folder-remove-outline' }]
    }
  },
  methods: {
    deleteItem (item) {
      console.log('deleteItem()', item)
      this.selectedItem = item
      this.batchDeleteDialog = true
    },
    clickDeleteBatch () {
      this.batchDeleteDialog = false
      const action = Models.Action
      action.TYPE = Models.ActionType.DELETE_BATCH
      action.Batch = Models.Batch
      action.Batch.Name = this.selectedItem.Name
      action.Batch.Id = this.selectedItem.Id
      this.ws._send(JSON.stringify(action))
    },
    clickRow (ev) {
      if (this.batchDeleteDialog) return
      console.log('clickRow()', ev)
      this.$emit('selectBatch', ev)
    },
    clickContextItem (item) {
      console.log('clickContextItem()', item)
    },
    clickContext (e) {
      console.log('clickContext()', e)
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    }
  }
}
</script>
